import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../hooks/redux'

const SmartRedirect: React.FC = () => {
  const { user } = useAppSelector(state => state.auth)

  // 根据用户类型进行智能重定向（仅用于根路径 /）
  if (user?.accountType === 'admin') {
    return <Navigate to="/admin/dashboard" replace />
  }
  
  if (user?.accountType === 'agent') {
    return <Navigate to="/customer-service" replace />
  }
  
  // 默认跳转到首页
  return <Navigate to="/home" replace />
}

export default SmartRedirect